import { createSlice } from '@reduxjs/toolkit'
import { LicenseEventsSchema } from '../types/LicenseEvent'
import { fetchLicenseEvents } from '../services/fetchLicenseEvents'

const initialState: LicenseEventsSchema = {
	limit: 10,
	error: '',
	isLoading: false,

	paginatedLicenseEvents: {
		currentPage: 1,
		items: []
	},
	filter: {},
	queryFilter: {},
	sort: {}
}

const licenseEventsSlice = createSlice({
	name: 'licenseEvents',
	initialState,
	reducers: {
		setPage: (state, action) => {
			state.paginatedLicenseEvents.currentPage = action.payload
		},
		resetPage: (state) => {
			state.paginatedLicenseEvents.currentPage = 1
		},
		setLimit: (state, action) => {
			state.limit = action.payload
		},
		setSort: (state, action) => {
			state.sort.sort = action.payload
		},
		setDirection: (state, action) => {
			state.sort.direction = action.payload
		},
		setUpdateTimeFrom: (state, action) => {
			state.filter.updateTimeFrom = action.payload
		},
		setUpdateTimeTo: (state, action) => {
			state.filter.updateTimeTo = action.payload
		},
		setQueryFilter: (state) => {
			state.queryFilter = { ...state.filter }
		},
		removeFilter: (state, action) => {
			const filterName: keyof typeof state.queryFilter = action.payload
			delete state.filter[filterName]
			delete state.queryFilter[filterName]
		},
		resetFilter: (state) => {
			state.filter = {}
			state.queryFilter = {}
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchLicenseEvents.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(fetchLicenseEvents.fulfilled, (state, action) => {
				const licenseEvents = action.payload

				state.paginatedLicenseEvents.items = licenseEvents
				state.paginatedLicenseEvents.totalCount = licenseEvents?.length ?? 0
				state.isLoading = false
			})
			.addCase(fetchLicenseEvents.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: licenseEventsActions } = licenseEventsSlice
export const { reducer: licenseEventsReducer } = licenseEventsSlice
